module.exports = __webpack_public_path__ + "assets/img/close-big.f11a65ae.svg";